export function Piercing({ className }: { className?: string }) {
  return (
    <svg
      version='1.1'
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      x='0px'
      y='0px'
      viewBox='0 0 90 90'
    >
      <line
        fill='none'
        stroke='currentColor'
        strokeMiterlimit={10}
        x1='-474.5'
        y1='-81.5'
        x2='-474.5'
        y2='-81.5'
      />
      <path fill='currentColor' d='M-259-378' />
      <path fill='currentColor' d='M-124.2,50.4' />
      <path fill='currentColor' d='M-118.3,166' />
      <path fill='currentColor' d='M-100.4,9.6' />
      <g id='XMLID_1_'>
        <path
          id='XMLID_2_'
          fill='currentColor'
          d='M45.2,3.8c-24.4,0-44.3,18.7-44.3,43c0,18.1,11.2,32.1,26.9,38c0.6,0.2,1.3,0.3,1.3,0.3
		c1.4,0.3,2.7,0.4,3.7,0.4c1.2,0.1,3.6-0.6,4.3-2.5c0.6-1.5-0.2-3.2-0.9-4c-0.6-0.7-1.4-1.1-2.8-1.7s-2.5-0.9-2.6-0.9
		c-3.2-1.3-12.4-5.6-17.4-15.6c-2.1-4.2-3.3-9-3.3-14.2c0-19.3,15.7-34,35-34s34.7,14.8,34.7,34c0,14.6-8.8,25.7-21.5,30.2
		c-0.1,0-0.2,0.1-0.2,0.1c-0.3,0.1-0.7,0.3-1.3,0.4c-1.8,0.7-2.8,1-3.1,1.2c-1.2,0.9-1.9,3.2-1.1,5.1c1.1,2.3,4,2.5,4.6,2.5
		c0.4,0,1.3-0.3,3.2-0.7c0,0,0.6-0.1,1-0.2C77.6,79.7,89,65.6,89,46.9C89.1,22.5,69.5,3.8,45.2,3.8z'
        />
      </g>
    </svg>
  );
}
